import React from 'react';
import styled from 'styled-components';
import { useAdminMaterialAliasStore } from '../../share/store/adminMaterialAliasStore';
import AdminBlockWithVisible from '../../share/component/AdminBlockWithVisible';
import AdminBlockWithSortVisible from '../../share/component/AdminBlockWithSortVisible';
import {
  MaterialAliasSortOrder,
  SortDirection,
} from '../../../shared/enum/EnumRepository';

const MaterialAliasColumnInfo: React.FC = () => {
  const {
    activeAlias,
    sortField,
    sortDirection,
    setSortData,
  } = useAdminMaterialAliasStore();

  const handleDirectionChange = (field: MaterialAliasSortOrder) => {
    const direction = sortField === field
      ? sortDirection === SortDirection.ASC
        ? SortDirection.DESC
        : SortDirection.ASC
      : SortDirection.ASC;
    setSortData(field, direction);
  };

  return (
    <ColumnInfoComp>
      <InfoContainer>
        <TitleBlock
          onClick={() =>
            handleDirectionChange(MaterialAliasSortOrder.KEYWORD)
          }
        >
          Keyword
          <SelectDirection
            $isASC={
              sortField === MaterialAliasSortOrder.KEYWORD
              && sortDirection === SortDirection.ASC
            }
            $isSortField={sortField === MaterialAliasSortOrder.KEYWORD}
          >
            ▼
          </SelectDirection>
        </TitleBlock>
        <AdminBlockWithSortVisible
          width="1"
          isColumn={true}
          value="Detected"
          isASC={
            sortField === MaterialAliasSortOrder.FREQUENCY
            && sortDirection === SortDirection.ASC
          }
          isSortField={sortField === MaterialAliasSortOrder.FREQUENCY}
          handleDirectionChange={() =>
            handleDirectionChange(MaterialAliasSortOrder.FREQUENCY)
          }
        />
        <AdminBlockWithVisible
          width="2"
          isColumn={true}
          value="Alias set"
        />
        {activeAlias && <SpaceBlock />}
      </InfoContainer>
      {activeAlias && <OverviewBlock>Overview</OverviewBlock>}
    </ColumnInfoComp>
  );
};

const ColumnInfoComp = styled.article`
  width: 100%;
  height: 38px;
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_02};

  ${({ theme }) => theme.typography.Body_03_2};
`;

const InfoContainer = styled.article`
  flex: 1;
  width: auto;
  height: 34px;
  display: flex;
`;

const TitleBlock = styled.div`
  flex: 2.4;
  display: flex;
  align-items: center;
  padding-left: 10px;
  cursor: pointer;
  user-select: none;
`;

const SelectDirection = styled.span<{
  $isSortField: boolean;
  $isASC: boolean;
}>`
  margin-left: 4px;
  ${({ theme }) => theme.typography.Footer_02};
  color: ${({ theme, $isSortField }) =>
    $isSortField
      ? theme.colors.color_Gray_03
      : theme.colors.color_Gray_05};
  transform: ${({ $isASC, $isSortField }) => {
    if (!$isSortField) return 'scale(0.7)';
    return $isASC ? 'scale(0.7)' : 'scaleY(-1) scale(0.7)';
  }};
  transition: transform 0.6s ease-in-out;
`;

const SpaceBlock = styled.div`
  flex: 0.15;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OverviewBlock = styled.div`
  width: 29vw;
  display: flex;
  align-items: center;
`;

export default MaterialAliasColumnInfo;
